import { Injectable, signal } from '@angular/core';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  public readonly user = signal<User | null>(null);
}
